import { NgxToasterService } from '@algomusinc/services';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-version-update',
  templateUrl: './version-update.component.html',
  styleUrls: ['./version-update.component.css']
})
export class VersionUpdateComponent implements OnInit {
  public visible = false;

  constructor(public dialogRef: DynamicDialogRef) { }

  ngOnInit() {
  }
  onConfirm() {
    this.visible = false;
    this.dialogRef.close(true);
  }

  onWait() {
    this.visible = true;
    this.dialogRef.close(false);
  }
}